import React, { useEffect, useState } from 'react';
import { apiFetch } from '../api';

interface FleetDevice {
    machineName: string;
    online: boolean;
    lastSeenAt: string | null;
}

const FleetDevices: React.FC = () => {
    const [devices, setDevices] = useState<FleetDevice[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const refresh = async () => {
        try {
            const response = await apiFetch('/admin/fleet-devices');
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            setDevices(await response.json());
            setError(null);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to load fleet devices');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refresh();
        const timer = window.setInterval(refresh, 30000);
        return () => window.clearInterval(timer);
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div style={{ color: 'red' }}>Error: {error}</div>;

    const onlineCount = devices.filter((device) => device.online).length;
    const sortedDevices = [...devices].sort(
        (a, b) => Number(a.online) - Number(b.online) || a.machineName.localeCompare(b.machineName),
    );

    return (
        <div style={{ height: '100%', overflow: 'auto' }}>
            <div style={{ marginBottom: '12px' }}>
                {onlineCount} online · {devices.length - onlineCount} offline
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={{ textAlign: 'left', padding: '10px', borderBottom: '1px solid #ddd' }}>Machine</th>
                        <th style={{ textAlign: 'left', padding: '10px', borderBottom: '1px solid #ddd' }}>Status</th>
                        <th style={{ textAlign: 'left', padding: '10px', borderBottom: '1px solid #ddd' }}>Last seen</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedDevices.map((device) => (
                        <tr key={device.machineName}>
                            <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>{device.machineName}</td>
                            <td style={{ padding: '10px', borderBottom: '1px solid #eee', color: device.online ? '#16803c' : '#c62828' }}>
                                ● {device.online ? 'Online' : 'Offline'}
                            </td>
                            <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                                {device.lastSeenAt ? new Date(device.lastSeenAt).toLocaleString() : 'Never'}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default FleetDevices;
